import { connect } from 'react-redux';

import NetworkMembershipActions from 'reducers/networkMembership';
import SubscriptionsActions from 'reducers/subscriptions';
import TrackingActions from 'reducers/tracking';

const mapStateToProps = ({ profile, contest, subscriptions }) => ({
  ...contest,
  golfSpecials: contest.pinnedBanners?.find((item) => item?.bannerType === 'golf_specials'),
  networkMembership: contest.pinnedBanners?.find((item) => item?.bannerType === 'network_membership'),
  hasNetworkMembership: profile.hasNetworkMembership,
  ...subscriptions,
});

const mapDispatchToProps = {
  ...NetworkMembershipActions,
  ...SubscriptionsActions,
  ...TrackingActions,
};

export default connect(mapStateToProps, mapDispatchToProps);
